import { useState, useEffect, useRef } from 'react'

export function useColumnResizing() {
  const [isResizing, setIsResizing] = useState(false)
  const [resizeIndex, setResizeIndex] = useState<number | null>(null)
  const [columnWidths, setColumnWidths] = useState<number[]>([
    50, 90, 85, 80, 95, 70, 75, 85, 85, 50, 70, 70, 100, 100, 200 // Initial column widths
  ])
  const tableRef = useRef<HTMLTableElement>(null)

  const handleResizeStart = (e: React.MouseEvent, index: number) => {
    e.preventDefault()
    e.stopPropagation()
    setIsResizing(true)
    setResizeIndex(index)
  }

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isResizing || resizeIndex === null || !tableRef.current) return

      const tableRect = tableRef.current.getBoundingClientRect()
      const relativeX = e.clientX - tableRect.left
      const newWidths = [...columnWidths]

      // Calculate width based on mouse position for the column being resized
      let totalPreviousWidths = 0
      for (let i = 0; i < resizeIndex; i++) {
        totalPreviousWidths += newWidths[i]
      }

      const newWidth = Math.max(30, relativeX - totalPreviousWidths)
      newWidths[resizeIndex] = newWidth
      setColumnWidths(newWidths)
    }

    const handleMouseUp = () => {
      setIsResizing(false)
      setResizeIndex(null)
    }

    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isResizing, resizeIndex, columnWidths])

  return {
    tableRef,
    columnWidths,
    handleResizeStart
  }
}